import type {
    ObligorRole,
    PaymentInstruction,
    ReceivingAccountKind,
} from './collectionModel';
import { newId } from './collectionModel';

export type PartyRole = Extract<ObligorRole, 'ASSIGNOR' | 'GUARANTOR'>;

export interface AgreementParty {
    id: string;
    role: PartyRole;
    roleFormatted?: string;
    fullName: string;
    documentNumber: string;
}

export interface CollectionOrderStep {
    role: ObligorRole;
    roleFormatted?: string;
    preventive: boolean;
    overdue: boolean;
}

export interface CollectionAgreement {
    id: string;
    serialId?: number;
    externalReference: string;
    policyId: string;
    policyName?: string | null;
    collect: boolean;
    collectionOrder: CollectionOrderStep[];
    receivingAccountKind: ReceivingAccountKind;
    receivingAccountKindFormatted?: string;
    payment: { instruction: PaymentInstruction; instructionFormatted?: string };
    assignorCount?: number;
    parties: AgreementParty[];
    notes: string | null;
    createdAt?: string | null;
    createdBy?: string | null;
    updatedAt?: string | null;
    updatedBy?: string | null;
}

export const PARTY_ROLE_LABEL: Record<PartyRole, string> = { ASSIGNOR: 'Cedente', GUARANTOR: 'Avalista' };

export const withLocalIds = (agreement: CollectionAgreement): CollectionAgreement => ({
    ...agreement,
    parties: (agreement.parties || []).map(party => ({ ...party, id: newId('party') })),
});
